/**
 * @description
 *
 * Вешаю слушатель на документ и при срабатывании события на переданных селекторах вызываю callback
 *
 * @param {object} options
 * @param {string} options.eventName - событие, которое будет прослушиваться
 * @param {Array} options.selectors - массив селекторов, на которых событие отлавливается
 * @param {Function} options.handlePaste - слушатель, который обрабатывает событие. Функции передается объект с 2 полями:
 * 1. {object} event - объект события
 * 2. {HTMLElement} targetNode - узел, на котором событие произошло
 */

function createEventListener(options = {}) {
  const {
    selectors = [],
    eventName = 'click',
    handleEvent = () => {},
  } = options

  document.addEventListener(eventName, event => {
    selectors.some(selector => {
      const targetNode = event.target?.closest?.(selector)

      if (targetNode) {
        handleEvent({
          event,
          targetNode,
        })
      }

      return !!targetNode
    })
  })
}

export default createEventListener
